<div class="card kpi-red">
    <div class="card-body kpi-card">
        <h5 class="card-title">
            Part travaux
            <i class="fa fa-question-circle" matTooltip="Part du montant des travaux sur le total du projet"></i>
        </h5>
        <p class="card-value">
            <ng-container *ngIf="preview">- %</ng-container>
            <ng-container *ngIf="!preview">
                {{ (favorite.works_total + favorite.other_fees_work) / favorite.total_price * 100| number:'1.1-1'}} %
            </ng-container>
        </p>
    </div>
</div>
